import { takeLatest, put, call } from 'redux-saga/effects';
import { DocumentsAction, DocumentsTypes, Document } from '../types';
import { getDocumentsList, saveDocument } from '../actions';
import { getDocumentsFirebase, saveDocumentFirebase } from '../repository';

export function* requestGetDocumentsListSaga(): unknown {
    try {
        const documents = yield call(getDocumentsFirebase);
        yield put(getDocumentsList(documents));
    } catch (err: unknown) {
        yield put(getDocumentsList([]));
    }
}

export function* requestSaveDocumentSaga(props: DocumentsAction<{ document: Document }>): unknown {
    try {
        const document = yield call(saveDocumentFirebase, props.payload.document);
        yield put(saveDocument(document));
    } catch (err: unknown) {
        yield put(saveDocument());
    }
}

export default [
    takeLatest(DocumentsTypes.REQUEST_GET_DOCUMENTS_LIST, requestGetDocumentsListSaga),
    takeLatest(DocumentsTypes.REQUEST_SAVE_DOCUMENT, requestSaveDocumentSaga),
];
